// Pre-fills Point 1/Point 2 raw values for sensors that predate the four-box UI
// (only k/c were ever stored) so their existing calibration still displays correctly.
// Once a sensor has its own stored raw1/raw2, these defaults are never used for it again.
export const DEFAULT_RAW_POINTS: Record<string, [number, number]> = {
    mA: [4, 20],
    PPM: [0, 100],
};

export const getDefaultRawPoints = (unit?: string): [number, number] => DEFAULT_RAW_POINTS[unit ?? ""] ?? [0, 100];

// Strips binary floating-point noise (e.g. 0.575 * 100 === 57.49999999999999)
// without arbitrarily truncating precision a user actually entered.
export const cleanFloat = (value: number) => Number(value.toPrecision(12));
